(function () {
    const searchTopbarMenu = document.querySelector('.search-topbar--menu');
    if (searchTopbarMenu) {
        const menuLinks = searchTopbarMenu.querySelectorAll('a');
        const globalHeaderMenus = document.querySelector('.global-header__menus');

        function removeActiveClasses() {
            menuLinks.forEach(function(link) {
                link.classList.remove('is-active');
            });
        }

        document.addEventListener('click', function(event) {
            if (globalHeaderMenus && !globalHeaderMenus.contains(event.target)) {
                removeActiveClasses();
            }
        });

        if (globalHeaderMenus) {
            globalHeaderMenus.addEventListener('mouseleave', function() {
                removeActiveClasses();
            });
        }
    }
})();
